import React, { Component } from 'react';
import styled from 'styled-components';

import Modal from '../../../../components/Modal';
import Button from '../../../../components/Button';

import FileContainer from './FileContainer';
import Icon from '../../../../components/Icon';
import { getFileExtensionByName } from '../../../../utils/file-helper';

const StyledModal = styled(Modal)`
  border-radius: 0 !important;
`;

const ContentContainer = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  margin: -24px -24px 0 -24px;
  background-color: var(--luft-primary);
  padding: 16px 24px;
  display: flex;
  align-items: center;

  & > i {
    font-size: 20px;
    color: white;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }
`;

const Title = styled.span`
  color: ${({ color }) => (color || 'white')};
  font-weight: bold;
  font-size: 18px;
  line-height: 23px;
  flex: 1;
`;

const DisclaimerTitle = styled.span`
  color: var(--luft-primary);
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
`;

const Disclaimer = styled.span`
  margin-top: 8px;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.38);
`;

const UploadButton = styled(Button)`
  margin-top: 16px;
`;

const UploadInput = styled.input`
  display: none;
`;

class PAEModal extends Component {
  constructor(props) {
    super(props);
    this.fileUploadInputRef = React.createRef();
  }

  getBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const binaryData = e.target.result;
      const base64Str = window.btoa(binaryData);

      resolve(base64Str);
    };

    reader.onerror = (e) => {
      reject(e);
    };

    reader.readAsBinaryString(file);
  });

  _openChooseFile = () => {
    this.fileUploadInputRef.current.click();
  };

  _isAcceptableExtension = (extensionList, extension) => {
    if (typeof extensionList !== 'undefined' && extensionList !== null) {
      if (Array.isArray(extensionList)) {
        return extensionList.indexOf(extension) > -1;
      } if (typeof (extension) === 'string') {
        return extensionList === extension;
      }
    }

    return true;
  };

  checkAcceptableExtension = (fileType, extensionName) => {
    const { acceptableExtensionsByFileName, acceptableExtensions } = this.props;
    return (this._isAcceptableExtension(acceptableExtensions, fileType)
      ? true : this._isAcceptableExtension(acceptableExtensionsByFileName, extensionName));
  };

  _handleChooseFile = async () => {
    const { onUploadFile } = this.props;

    const fileToUpload = this.fileUploadInputRef.current.files[0];
    if (!fileToUpload) return;

    const extensionName = getFileExtensionByName(fileToUpload.name);

    if (!this.checkAcceptableExtension(fileToUpload.type, extensionName)) {
      return;
    }

    this.fileUploadInputRef.current.value = '';
    fileToUpload.base64 = await this.getBase64(fileToUpload);

    onUploadFile(fileToUpload);
  };

  render() {
    const { paeDocumentData, onDismiss } = this.props;

    const {
      isLoading,
      isNew,
      file,
      uploadedDate,
      userName,
    } = paeDocumentData;

    return (
      <StyledModal
        size="small"
      >
        <Header>
          <Title>Configurações</Title>
          <Icon
            name="close"
            onClick={onDismiss}
          />
        </Header>
        <ContentContainer>
          <Title color="#263465" >Documento PAE MG</Title>
          <FileContainer
            uploadedDate={uploadedDate}
            isLoading={isLoading}
            isNew={isNew}
            file={file}
            userName={userName}
          />
          <DisclaimerTitle>Subir novo documento</DisclaimerTitle>
          <Disclaimer>
          Ao subir um novo documento PAE a versão anterior não estará mais disponível aqui. Caso necessite da versão como histórico, recomendados que faça o download da mesma.
          </Disclaimer>
          <Disclaimer>
          O novo documento PAE será atualizado em todos os apps, no momento em que estes sincronizarem suas viagens.
          </Disclaimer>
          <UploadButton
            skin="primary"
            text="subir novo pae"
            disabled={isLoading}
            onClick={() => this._openChooseFile()}
          />
          <UploadInput
            type="file"
            ref={this.fileUploadInputRef}
            onChange={this._handleChooseFile}
          />
        </ContentContainer>
      </StyledModal>
    );
  }
}

export default PAEModal;
